import axios, {AxiosError, HttpStatusCode} from 'axios'
import {BaseResponse} from '@/interfaces'
import Router from 'next/router'
import {createUserStore} from '@/store/userStore'
import {ApiAbortControllerService} from '@/services/ApiAbortController'

export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_VENDOR_BASE_URL,
  headers: {
    'Consumer-key': process.env.NEXT_PUBLIC_API_CONSUMER_KEY,
  },
})

api.defaults.signal = ApiAbortControllerService.getSignal()

api.interceptors.response.use(
  response => response,
  err => {
    const error = err as AxiosError<BaseResponse<null>>
    if (error.status === HttpStatusCode.Unauthorized) {
      const {logout, user} = createUserStore.getState()
      const path = Router.pathname
      const isInHomePage = path === '/' || path.includes('home')
      if (user) logout()
      if (!isInHomePage) {
        Router.replace({
          pathname: '/',
          query: {expired: true},
        })
      }
    }
    return Promise.reject(error)
  },
)
